import { useSelector } from "react-redux";

export function useLoggedIn() {
  const userInfo = useSelector((s) => s.userInfo) || {};
  return !!userInfo.id;
}
